import React from 'react';
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';
import { DesktopDatePicker, MobileDatePicker } from '@mui/x-date-pickers';
import Box from '@mui/material/Box';
import { dateRowStyle, dateArrowIconStyle, dateCalendarIconStyle, clearIconStyle } from '../DatesSelector.style';
import { Z_INDEX_OVERRIDE } from '../utils/constants';
import CalendarMonth from '@mui/icons-material/CalendarMonth';
import ClearIcon from '@mui/icons-material/Clear';
export const DatePicker = (props) => {
    return (React.createElement(Box, { sx: dateRowStyle },
        React.createElement(SubdirectoryArrowRightIcon, { sx: dateArrowIconStyle }),
        props.isMobile ? (React.createElement(React.Fragment, null,
            React.createElement(MobileDatePicker, Object.assign({}, props, { InputProps: {
                    sx: dateCalendarIconStyle,
                }, DialogProps: {
                    sx: { zIndex: Z_INDEX_OVERRIDE },
                } })),
            props.onReset && (React.createElement(Box, { sx: clearIconStyle, onClick: () => { props.onReset && props.onReset(); } },
                React.createElement(ClearIcon, null))))) : (React.createElement(DesktopDatePicker, Object.assign({}, props, { components: {
                OpenPickerIcon: CalendarMonth,
            }, InputProps: {
                sx: dateCalendarIconStyle,
            } })))));
};
